import { render, staticRenderFns } from "./StudyNewPageUnanswered.vue?vue&type=template&id=73af55cc&scoped=true"
import script from "./StudyNewPageUnanswered.vue?vue&type=script&lang=js"
export * from "./StudyNewPageUnanswered.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageUnanswered.vue?vue&type=style&index=0&id=73af55cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af55cc",
  null
  
)

export default component.exports